import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  faArrowRight,
  faExclamationTriangle
} from '@fortawesome/pro-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface IFooterButton {
  text: string;
  color?: string;
  icon?: IconDefinition;
}

export interface ICtdUnpaidModalComponent {
  footerButtons: IFooterButton[];
  content: string;
}

@Component({
  selector: 'pos-ctd-unpaid-modal',
  templateUrl: './ctd-unpaid-modal.component.html',
  styleUrls: ['./ctd-unpaid-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtdUnpaidModalComponent {
  @Input() footerButtons: IFooterButton[] = [];
  @Input() content = '';

  readonly faExclamationTriangle = faExclamationTriangle;
  readonly faArrowRight = faArrowRight;

  constructor(private readonly modalCtrl: ModalController) {}

  onFooterBtnClick(index: number) {
    this.modalCtrl.dismiss(index);
  }
}
